const cols = [
  {
    title: "图集栏目",
    links: [
      { label: "现场直击", id: "live" },
      { label: "热门事件", id: "events" },
      { label: "主题图集", id: "themes" },
      { label: "高清生图", id: "gallery" },
      { label: "精选合集", id: "collections" },
    ],
  },
  {
    title: "热门主题",
    links: [
      { label: "红毯盛典生图", id: "themes" },
      { label: "发布会现场路透", id: "events" },
      { label: "综艺录制侧拍", id: "gallery" },
      { label: "机场穿搭抓拍", id: "gallery" },
      { label: "音乐现场氛围", id: "live" },
    ],
  },
  {
    title: "帮助与联系",
    links: [
      { label: "关于吃瓜图集", id: "about" },
      { label: "常见问题", id: "faq" },
      { label: "投稿与线索", id: "contact" },
      { label: "订阅现场直击", id: "contact" },
    ],
  },
];

const socials = [
  { icon: "ri-weibo-line", label: "微博" },
  { icon: "ri-wechat-line", label: "微信" },
  { icon: "ri-tiktok-line", label: "抖音" },
  { icon: "ri-pinterest-line", label: "图片社区" },
];

const go = (id: string) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export default function Footer() {
  return (
    <footer className="w-full bg-primary-900 text-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-10">
          <div className="col-span-2 md:col-span-1">
            <a
              href="#top"
              onClick={(e) => {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              className="flex items-center gap-2.5 cursor-pointer"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-500 text-background-50">
                <i className="ri-camera-lens-fill text-lg"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="text-lg font-heading font-bold tracking-tight">吃瓜图集</span>
                <span className="mt-1 text-[10px] tracking-[0.2em] text-background-100/70">现场生图 · 一网打尽</span>
              </span>
            </a>
            <p className="mt-4 text-sm leading-relaxed text-background-100/80 max-w-xs">
              聚合活动现场实拍图、路透照与高清生图的图集站，按事件持续更新，点开就看各路现场直出。
            </p>
            <div className="mt-4 flex items-center gap-2">
              {socials.map((s) => (
                <a
                  key={s.label}
                  href="#top"
                  onClick={(e) => {
                    e.preventDefault();
                    window.dispatchEvent(new CustomEvent("chigua:toast", { detail: `${s.label} 账号暂未开放，敬请期待` }));
                  }}
                  aria-label={s.label}
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 text-background-100 hover:bg-accent-500 hover:text-background-50 transition cursor-pointer"
                >
                  <i className={`${s.icon}`}></i>
                </a>
              ))}
            </div>
          </div>

          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="text-sm font-semibold text-accent-300 tracking-wide">{c.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {c.links.map((l, i) => (
                  <li key={i}>
                    <button
                      onClick={() => go(l.id)}
                      className="text-sm text-background-100/80 hover:text-background-50 hover:pl-1 transition-all whitespace-nowrap cursor-pointer"
                    >
                      {l.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-100/60">
            © {new Date().getFullYear()} 吃瓜图集 · 高清现场生图聚合站。实拍图片版权归拍摄方与投稿者所有。
          </p>
          <p className="text-xs text-background-100/60 flex items-center gap-1.5">
            <i className="ri-links-line"></i> 找图不用来回翻
          </p>
        </div>
      </div>
    </footer>
  );
}